// // CancellationModal.jsx
// import React, { useState, useEffect } from 'react';
// import apiCall from '../helper/apiCall';
// import { toast } from 'react-toastify';
// import Spinner from './Spinner';

// const CancellationModal = ({ showModal, onClose, onConfirm, orderItemId, orderData }) => {
//     const [cancellationReasons, setCancellationReasons] = useState([]);
//     const [selectedReason, setSelectedReason] = useState('');
//     const [comments, setComments] = useState('');
//     const [loading, setLoading] = useState(false);

//     useEffect(() => {
//         if (showModal) {
//             const fetchReasons = async () => {
//                 setLoading(true);
//                 try {
//                     const response = await apiCall("getCancellationReasons");
//                     if (response?.success) {
//                         setCancellationReasons(response.data);
//                     } else {
//                         console.error("Failed to fetch cancellation reasons:", response?.message);
//                         toast.error("Failed to load cancellation reasons.");
//                     }
//                 } catch (error) {
//                     console.error("API call error:", error);
//                     toast.error("An error occurred while fetching reasons.");
//                 } finally {
//                     setLoading(false);
//                 }
//             };
//             fetchReasons();
//         }
//     }, [showModal]);

//     const handleConfirm = async () => {
//         if (!selectedReason) {
//             toast.error("Please select a cancellation reason.");
//             return;
//         }

//         const { order_id } = orderData;

//         let shipment_id;
//         for (const shipment of orderData.shipments) {
//             const foundItem = shipment.items.find(item => item.order_item_id === rejectionData.order_item_id);
//             if (foundItem) {
//                 shipment_id = shipment.shipment_id;
//                 break;
//             }
//         }
//         if (!shipment_id) {
//             toast.error('Could not find shipment for the selected item.');
//             return;
//         }

//         // Combine all necessary data into a single payload
//         const payload = {
//             order_item_id: orderItemId,
//             cancellation_reason_id: selectedReason,
//             comments: comments,
//             order_id,
//             shipment_id,
//         };

//         const response = await apiCall("createCancellation", payload); // Replace with your actual reject API call
//         if (response.success) {
//             toast.success(response?.message || 'Order item rejected successfully.');
//             onConfirm(true);
//             onClose();
//         } else {
//             toast.error(response?.message || 'Failed to reject order item.');
//         }







//     };

//     if (!showModal) {
//         return null;
//     }

//     return (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
//             <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
//                 <h3 className="text-xl font-semibold mb-4">Reject Order Item</h3>
//                 <div className="space-y-4">
//                     <label className="block text-sm font-medium text-gray-700">Cancellation Reason</label>
//                     {loading ? (
//                         <div className="flex justify-center items-center h-10">
//                             <Spinner />
//                         </div>
//                     ) : (
//                         <select
//                             value={selectedReason}
//                             onChange={(e) => setSelectedReason(e.target.value)}
//                             className="w-full px-4 py-2 border rounded-md"
//                         >
//                             <option value="" disabled>Select a reason</option>
//                             {cancellationReasons.map((reason) => (
//                                 <option key={reason.cancellation_reason_id} value={reason.cancellation_reason_id}>
//                                     {reason.cancellation_reason_description}
//                                 </option>
//                             ))}
//                         </select>
//                     )}
//                     <label className="block text-sm font-medium text-gray-700">Comments</label>
//                     <textarea
//                         value={comments}
//                         onChange={(e) => setComments(e.target.value)}
//                         placeholder="Add optional comments..."
//                         rows="4"
//                         className="w-full px-4 py-2 border rounded-md"
//                     ></textarea>
//                 </div>
//                 <div className="mt-6 flex justify-end space-x-4">
//                     <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300">
//                         Cancel
//                     </button>
//                     <button onClick={handleConfirm} className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700">
//                         Confirm Rejection
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CancellationModal;


// CancellationModal.jsx
import React, { useState, useEffect, useCallback } from 'react';
import apiCall from '../helper/apiCall';
import { toast } from 'react-toastify';
import Spinner from './Spinner';

const CancellationModal = ({ showModal, onClose, onConfirm, orderItemId, orderData }) => {
  const [cancellationReasons, setCancellationReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState('');
  const [comments, setComments] = useState('');
  const [loading, setLoading] = useState(false);

  // Memoize the API call to fetch reasons to avoid re-creation on every render
  const fetchReasons = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiCall("getCancellationReasons");
      if (response?.success) {
        setCancellationReasons(response.data);
      } else {
        console.error("Failed to fetch cancellation reasons:", response?.message);
        toast.error("Failed to load cancellation reasons.");
      }
    } catch (error) {
      console.error("API call error:", error);
      toast.error("An error occurred while fetching reasons.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (showModal) {
      fetchReasons();
    }
  }, [showModal, fetchReasons]); // Add fetchReasons to dependency array

  const handleConfirm = async () => {
    if (!selectedReason) {
      toast.error("Please select a cancellation reason.");
      return;
    }

    const { order_id } = orderData.data;

    // Use a more efficient method to find the shipment_id
    const shipment = orderData.data.shipments.find(s => s.items.some(item => item.order_item_id === orderItemId));

    if (!shipment) {
      toast.error('Could not find shipment for the selected item.');
      return;
    }
    
    const shipment_id = shipment.shipment_id;

    const payload = {
      order_item_id: orderItemId,
      cancellation_reason_id: selectedReason,
      comments: comments,
      order_id,
      shipment_id,
    };

    try {
      setLoading(true); // Add loading state for the confirmation process
      const response = await apiCall("createCancellation", payload);
      if (response.success) {
        toast.success(response?.message || 'Order item rejected successfully.');
        onConfirm(true);
        onClose();
      } else {
        toast.error(response?.message || 'Failed to reject order item.');
      }
    } catch (err) {
      toast.error('Failed to reject order item. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
        <h3 className="text-xl font-semibold mb-4">Reject Order Item</h3>
        <div className="space-y-4">
          <label className="block text-sm font-medium text-gray-700">Cancellation Reason</label>
          {loading ? (
            <div className="flex justify-center items-center h-10">
              <Spinner />
            </div>
          ) : (
            <select
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="w-full px-4 py-2 border rounded-md"
            >
              <option value="" disabled>Select a reason</option>
              {cancellationReasons.map((reason) => (
                <option key={reason.cancellation_reason_id} value={reason.cancellation_reason_id}>
                  {reason.cancellation_reason_description}
                </option>
              ))}
            </select>
          )}
          <label className="block text-sm font-medium text-gray-700">Comments</label>
          <textarea
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder="Add optional comments..."
            rows="4"
            className="w-full px-4 py-2 border rounded-md"
          ></textarea>
        </div>
        <div className="mt-6 flex justify-end space-x-4">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300">
            Cancel
          </button>
          <button onClick={handleConfirm} disabled={loading} className={`px-4 py-2 text-white rounded-md ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}>
            {loading ? <Spinner /> : 'Confirm Rejection'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancellationModal;